import React from "react";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";
import { apiProviders } from "../../variables/app";

function ApiProviderFilter(props) {
  const { classes } = props;

  const apiProvidersList = [
    {
      value: "0",
      label: "All Api Providers",
    },
    ...apiProviders,
    {
      value: "NULL",
      label: "No Api Provider",
    },
  ];

  return (
    <Select
      MenuProps={{
        className: classes.selectMenu,
      }}
      classes={{
        select: classes.select,
      }}
      inputProps={{
        name: "simpleSelect",
        id: "simple-select",
        style: { paddingTop: "32px" },
      }}
      onChange={(e) => {
        let value = e.target.value;

        switch (value) {
          case "0":
            props.setFilter("apiProvider", null);
            break;
          case "NULL":
            props.setFilter("apiProvider", { field: "apiProvider", operator: null, value: null });
            break;
          default:
            props.setFilter("apiProvider", { field: "apiProvider", operator: "=", value: value });
            break;
        }
      }}
      style={{ backgroundColor: props.apiProvider === null ? null : "#ff9800" }}
      value={props.apiProvider?.value ? props.apiProvider.value : props.apiProvider == null ? "0" : "NULL"}
    >
      {apiProvidersList.map((item) => (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={item.value}
          value={item.value}
        >
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

const mapStateToProps = (state) => ({
  ["apiProvider"]: state.filtersV2["apiProvider"],
  /*   ["vestiging_id"]: state.filtersV2["vestiging_id"], */
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(ApiProviderFilter, productenStyle));
